"use strict";

var _interopRequireWildcard = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _JZYSDK = _interopRequireDefault(require("@/utils/JZYSDK"));

var util = _interopRequireWildcard(require("@/utils/util"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'Share',
  filters: {},
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    styleMode: {
      type: String,
      default: function _default() {
        return 'light';
      }
    }
  },
  data: function data() {
    return {
      themeStyle: 'light'
    };
  },
  computed: {
    isDarkTheme: function isDarkTheme() {
      return this.styleMode === 'dark' || this.themeStyle === 'dark';
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.themeStyle = util.getSystemTheme() || 'light';
  },
  methods: {
    share: function share(data, type) {
      // 分享
      // 调用原生SDK进行分享
      // console.log(type + '分享')
      // console.log(data)
      // console.log({
      //   type: type, // 类型 wx | pyq | wb
      //   title: data.Title, // 分享标题
      //   desc: data.Summary, // 分享描述
      //   link: data.url, // 分享链接
      //   imgUrl: 'https://dev-kgl.jt00000.com/app-client/static/logo.png' // 分享图标  随便给个先
      // })
      (0, _JZYSDK.default)('nativeShare', {
        type: type,
        // 类型 wx | pyq | wb
        title: data.Title,
        // 分享标题
        desc: data.Summary,
        // 分享描述
        link: data.url,
        // 分享链接
        imgUrl: location.protocol + '//' + process.env.VUE_APP_BASE_API + '/app-client/static/logo.png' // 分享图标  随便给个先

      });
    }
  }
};
exports.default = _default2;